<template>
  <v-container>
    <v-row justify="center">
      <!-- Profile Section -->
      <v-col cols="12" md="8">
        <v-card flat border class="pa-4">
          <v-card-title class="text-center">
            <v-avatar variant="tonal" size="56" color="primary" class="mx-auto">
              {{ viewModel.getUserInitials() }}
            </v-avatar>
          </v-card-title>
          <v-card-subtitle class="text-center pb-4">
            <span class="font-weight-bold">
              {{ viewModel.getFormattedName() }}
            </span>
          </v-card-subtitle>
          <v-divider></v-divider>
          <v-card-text>
            <v-list>
              <v-list-item>
                <template #default>
                  <v-list-item-title>ID de Socio</v-list-item-title>
                  <v-list-item-subtitle>
                    {{ viewModel.userinfo.value?.idsocio }}
                  </v-list-item-subtitle>
                </template>
              </v-list-item>
              <v-list-item
                v-if="
                  viewModel.userinfo.value?.telmovil ||
                  viewModel.userinfo.value?.telfijo
                "
              >
                <template #default>
                  <v-list-item-title>Teléfono</v-list-item-title>
                  <v-list-item-subtitle>
                    {{ viewModel.getHiddenPhone() }}
                  </v-list-item-subtitle>
                </template>
              </v-list-item>
              <v-list-item>
                <template #default>
                  <v-list-item-title>Correo</v-list-item-title>
                  <v-list-item-subtitle>
                    {{ viewModel.getHiddenEmail() }}
                  </v-list-item-subtitle>
                </template>
              </v-list-item>
            </v-list>
          </v-card-text>
        </v-card>
      </v-col>
      <!-- Options Section -->
      <v-col cols="12" md="8">
        <v-card flat border class="pa-4">
          <v-card-title class="text-subtitle-1 font-weight-bold"
            >Opciones</v-card-title
          >
          <v-divider></v-divider>
          <v-list>
            <v-list-item>
              <template #prepend>
                <v-icon>mdi-power-settings</v-icon>
              </template>
              <template #default>
                <v-list-item-title class="text-subtitle-1"
                  >Cierre de sesión automático</v-list-item-title
                >
              </template>
              <template #append>
                <v-switch
                  color="primary"
                  v-model="viewModel.session.value"
                  density="compact"
                  hide-details
                />
              </template>
            </v-list-item>
            <v-list-item @click="viewModel.goToWsp">
              <template #prepend>
                <v-icon>mdi-headset</v-icon>
              </template>
              <template #default>
                <v-list-item-title class="text-subtitle-1"
                  >Ayuda y Soporte</v-list-item-title
                >
              </template>
            </v-list-item>

            <v-list-item>
              <template #prepend>
                <v-icon>mdi-theme-light-dark</v-icon>
              </template>
              <template #default>
                <v-list-item-title class="text-subtitle-1"
                  >Modo Oscuro</v-list-item-title
                >
              </template>
              <template #append>
                <v-switch
                  color="primary"
                  v-model="viewModel.isDarkMode.value"
                  density="compact"
                  hide-details
                />
              </template>
            </v-list-item>
            <v-list-item @click="viewModel.logout">
              <template #prepend>
                <v-icon>mdi-logout</v-icon>
              </template>
              <template #default>
                <v-list-item-title class="text-subtitle-1"
                  >Salir de la aplicación</v-list-item-title
                >
              </template>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script lang="ts" setup>
import SettingsViewModel from "@/viewmodels/app/SettingsViewModel";

const viewModel = new SettingsViewModel();
</script>
